<template>
    <section class="main">
        <HeadSectionMain :data="head" class="fill-height"/>
        <OurProducts />
        <h1 class="title">{{ title[lang]}}</h1>
        <template v-for="(product, i) in listProducts" :key="i">
            <productComponent :data="product"
                              :src-img="'products/xCargoVision/'"
                              :class="[
                                  i%2 && 'color-gray',
                              ]"
            >
            </productComponent>
        </template>
        <ourMobileApplication />
        <infoComponent class="white-bg"/>
    </section>
</template>

<script>
export default {
    name: "xCargoVisionPage",
    data() {
        return {
            jsonFile: '',
            title: {
                en: "xCargo Vision",
                es: "xCargo Vision",
                pt: "xCargo Vision",
            }
        }
    },
    computed: {
        lang() {
            return this.$i18n.locale
        },
        head(){
            return this.jsonFile?.head
        },
        listProducts() {
            return this.jsonFile?.list_products
        },
    },
    created() {
        this.jsonFile = require('../../pages/xCargo-vision.json');
    },
    mounted() {
    }
}
</script>

<style lang="scss" scoped>
.main {
    .title {
        text-align: center;
        background: white;
        padding: 60px 0;
    }
    .product-item {
        &.color-gray {
            background: #FAFBFD;
        }
        &.color-white {
            background: white;
        }
    }
    .white-bg {
        position: relative;
        background: white;
        padding: 85px 0;
        margin-top: -250px;
    }
    .sensors {
        display: grid;
        grid-template-columns: repeat(3, 100px);
        gap: 10px;

        &__item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        &__title {
            text-align: center;
        }
    }
}
@media all and (max-width: 1550px) {
    .main {
        .white-bg {
            margin-top: -15%;
        }
        .sensors-wrap {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }
}
</style>